/**
 * Asginaciones de preguntas a periodo y boleta
 */

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types

export const OBTENER_HISTORIAL_REVISIONES_RESPUESTA = "obtenerHistorialRevisionesRespuesta";
export const REGISTRAR_HISTORIAL_REVISION_RESPUESTA = "asignarHistorialRevisionRespuesta";
export const REGISTRAR_HISTORIAL_APROBACION_RESPUESTA = "asignarHistorialAprobacionRespuesta";
//export const OBTENER_PREGUNTA_PERIODO_BOLETA = "obtenerHistorialRevisionRespuesta";
export const ACTUALIZAR_HISTORIAL_REVISION_RESPUESTA = "actualizarHistorialRevisionRespuesta";

// mutation types
export const SET_HISTORIAL_REVISIONES_RESPUESTA = "sethistorialRevisionRespuesta";
export const SET_HISTORIAL_REVISION_RESPUESTA = "sethistorialRevisionRespuesta";
export const SET_HISTORIAL_APROBACION_RESPUESTA = "setHistorialAprobacionRespuesta";

const state = {
    historialRevisionesRespuesta:[],
    historialAprobaciones:[],   
    historialRevisiones:[] 
}

const getters = {
    obtenerhistorialRevisionesRespuestas(state) {
      return state.boletas;
    },
}

const actions = {

   
    /**
     * Obtener el historial de revisiones de una respuesta específica
     * @param {*} context 
     * @param {*} estadoId 
     * @returns 
     */
    
    async [OBTENER_HISTORIAL_REVISIONES_RESPUESTA](context, respuestaMuniId) {
        let endpoint = `/api/RevisionRespuesta/historial/${respuestaMuniId}`;
       
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_HISTORIAL_REVISION_RESPUESTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    },

    /**
     * Registrar un item para el historial de revisiones respuesta
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    async [REGISTRAR_HISTORIAL_REVISION_RESPUESTA](context, datos){

        let endpoint=`api/RevisionRespuesta`;

        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=${endpoint}`, datos)
                .then(({ data }) => {
                    context.commit(SET_HISTORIAL_REVISION_RESPUESTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


     /**
     * Registrar un item para el historial de aprobaciones por respuesta
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
      async [REGISTRAR_HISTORIAL_APROBACION_RESPUESTA](context, datos){

        let endpoint=`api/RevisionRespuesta/Aprobacion`;

        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=${endpoint}`, datos)
                .then(({ data }) => {
                    context.commit(SET_HISTORIAL_APROBACION_RESPUESTA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },


    


    




    
}

const mutations = {
    [SET_HISTORIAL_REVISIONES_RESPUESTA](state, data) {
        state.boletas = data;
    },

    [SET_HISTORIAL_REVISION_RESPUESTA](state, data) {
        state.historialRevisiones = data;
    },

    [SET_HISTORIAL_APROBACION_RESPUESTA](state, data) {
        state.historialAprobaciones = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}